import React from 'react';
import styles from './Breadcrumb.module.css';
import { Breadcrumb as BreadcrumbType, useGlobalStore } from '@/stores';
import LeftArrowIcon from '@/assets/icons/ic-arrow-left.svg';

interface BreadcrumbProps {
    onActiveTab?: (to: string, query?: Record<string, string>, params?: Record<string, string>) => void;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ onActiveTab }) => {
    const getBreadcrumbs = useGlobalStore(state => state.breadcrumbs);
    const breadcrumbs = getBreadcrumbs || [];

    const filteredBreadcrumbs = breadcrumbs.filter(b => b.title);
    const showBackButton = breadcrumbs?.length > 1;
    const breadCrumbSize = breadcrumbs?.length ?? 0;
    const currentPage = breadcrumbs?.[breadCrumbSize - 1];
    const previousPage = breadcrumbs?.[breadCrumbSize - 2];

    const goBack = () => {
        if (previousPage && onActiveTab) {
            onActiveTab(previousPage.to, previousPage.query, previousPage.params);
        }
    };

    const handleBreadcrumbClick = (item: BreadcrumbType) => {
        if (item.to && onActiveTab) {
            onActiveTab(item.to, item.query, item.params);
        }
    };
    return (
        <nav aria-label='breadcrumb transparent' className='flex items-center'>
            {showBackButton && (
                <LeftArrowIcon
                    width={24}
                    height={24}
                    className={`${styles['back-button']} mr-2 cursor-pointer`}
                    onClick={goBack}
                />
            )}

            {/* Desktop breadcrumb */}
            <ol className={`${styles.breadcrumb} transparent mb-0 hidden px-0 lg:inline-flex`}>
                {filteredBreadcrumbs.map(item => (
                    <li
                        key={item.title}
                        className={`breadcrumb-item text-lg font-bold ${item.active ? styles.active : ''}`}
                        aria-current={item.active ? 'page' : undefined}
                    >
                        {item.to ? (
                            <a
                                className='m-0 cursor-pointer p-0'
                                onClick={() => handleBreadcrumbClick(item)}
                                role='button'
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        handleBreadcrumbClick(item);
                                    }
                                }}
                            >
                                {item.title}
                            </a>
                        ) : (
                            <span>{item.title}</span>
                        )}
                    </li>
                ))}
            </ol>

            {/* Mobile breadcrumb */}
            <div className={`${styles.breadcrumb} breadcrumb transparent mb-0 inline-flex px-0 lg:hidden`}>
                {currentPage && (
                    <div
                        className={`text-lg font-bold ${currentPage.active ? styles.active : ''}`}
                        aria-current={currentPage.active ? 'page' : undefined}
                    >
                        {currentPage.to ? (
                            <a
                                className='m-0 cursor-pointer p-0'
                                onClick={() => handleBreadcrumbClick(currentPage)}
                                role='button'
                                tabIndex={0}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        handleBreadcrumbClick(currentPage);
                                    }
                                }}
                            >
                                {currentPage.title}
                            </a>
                        ) : (
                            <span>{currentPage.title}</span>
                        )}
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Breadcrumb;
